const baseRoutes = {
    root: '/',
    login: '/login',
    landing: '/landing',
    settings: '/settings',
    sampleListPage: '/sample',
    sampleCreatePage: '/sample/new',
    sampleEditPage: '/sample/:id',
};

const adminRoutes = {
    appNameListPage: '/app-name',
    appNameCreatePage: '/app-name/new',
    appNameEditPage: '/app-name/:id',
};

export {
    adminRoutes,
    baseRoutes,
};
